import ReportIndexPage from "../components/report/index";
import BrandLiftReport from "../components/report/report/brandLiftReport/index";
import ReportPage from "../components/report/report/index";

export const Routes = (flags = {}) => {
  const { whitelabelBrandLiftCampaign } = flags;

  const routes = [
    {
      component: ReportIndexPage,
      path: "/reports",
      title: ["Reports"],
    },
  ];

  if (whitelabelBrandLiftCampaign) {
    routes.push({
      component: BrandLiftReport,
      path: "/report/brand-lift",
      title: ["Brand Lift Report"],
    });
  }

  routes.push({
    component: ReportPage,
    path: "/report/:report_slug",
    title: ["Report"],
  });

  return routes;
};
